import moment from 'moment/moment';
import { FerryTripEntity } from 'Models/Entities';
import { isNotNullOrUndefined } from 'Util/TypeGuards';
import { BookingWizardData } from 'Views/Components/_HumanWritten/BookingWizard/FerryTripBookingWizard/BookingWizardData/BaseBookingWizardData';
import { SelectedTrips } from 'Views/Components/_HumanWritten/BookingWizard/FerryTripBookingWizard/BookingWizardWrap';

// Checks if the return trip date is after the departure trip date
export const isInvalidReturnTripDate = (wizardData: BookingWizardData) => {
	return moment(wizardData.startDate).toDate() > moment(wizardData.endDate).toDate();
};

// Checks if the start/end date is the same as the selected trip date
export const isSameDate = (wizardData: BookingWizardData, selectedTrips: SelectedTrips, departureTicket: boolean) => {
	let sidebarDate = true;
	let selectedTabDate = true;
	if (departureTicket) {
		sidebarDate =
			moment(selectedTrips.departingTrip?.startDate).format('YYYY-MM-DD') ===
			moment(wizardData.startDate).format('YYYY-MM-DD');
		selectedTabDate =
			moment(selectedTrips.departingTrip?.startDate).format('YYYY-MM-DD') ===
			moment(wizardData.ticketSelectionStartDate).format('YYYY-MM-DD');
	}
	if (!departureTicket && !!selectedTrips.returningTrip) {
		sidebarDate =
			moment(selectedTrips.returningTrip.startDate).format('YYYY-MM-DD') ===
			moment(wizardData.endDate).format('YYYY-MM-DD');
		selectedTabDate =
			moment(selectedTrips.returningTrip.startDate).format('YYYY-MM-DD') ===
			moment(wizardData.ticketSelectionEndDate).format('YYYY-MM-DD');
	}
	return sidebarDate || selectedTabDate;
};

// If the return trip date is after the departure trip date, unselect the return trip
export const unselectInvalidDateTicket = (
	wizardData: BookingWizardData,
	departureTrip?: FerryTripEntity,
	returningTrip?: FerryTripEntity,
) => {
	// Feature: Multi-select - TODO unselect invalid ticket
	if (isInvalidReturnTripDate(wizardData)) {
		wizardData.endDate = wizardData.startDate;
		wizardData.ticketSelectionEndDate = wizardData.endDate;

		// If the new selected departure ferry ticket departure dateTime
		// is after the select destination ticket dateTime, deselect it
		if (!!returningTrip && !!departureTrip && departureTrip.departureDateTime >= returningTrip.departureDateTime) {
			wizardData.returningTicketId = '';
			wizardData.returningJourney = undefined;
		}
	}
};

/**
 * Keeps the returning day from falling before the departing day the booker has just moved to.
 *
 * <p>For a move of the selected day only (a day on the rail, or a tab), which leaves the rail's own
 * dates where they were. The returning leg's selected day and rail both move onto the new departing
 * day, as they do when the rail itself moves past the return.</p>
 */
export const keepReturnDayAfterDeparture = (wizardData: BookingWizardData) => {
	if (
		moment(wizardData.ticketSelectionStartDate).startOf('day')
			.isAfter(moment(wizardData.ticketSelectionEndDate).startOf('day'))
	) {
		wizardData.endDate = wizardData.ticketSelectionStartDate;
		wizardData.ticketSelectionEndDate = wizardData.ticketSelectionStartDate;
	}
};

// Check if a date is before today's date (does not take time into consideration)
export function isDateBeforeToday(dateToCompare: Date) {
	if (isNotNullOrUndefined(dateToCompare)) {
		const currentDateTime = new Date();
		const dateOfToday = new Date(
			currentDateTime.getUTCFullYear(),
			currentDateTime.getUTCMonth(),
			currentDateTime.getUTCDate(),
		);

		const date = new Date(dateToCompare);
		const formattedDateToCompare = new Date(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate());

		return dateOfToday > formattedDateToCompare;
	}
	return true;
}
